// Others
import axiosClient from './axiosClient';
import { urlApiEmployee } from '~/utils/constants/apis';
import { IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IBodyUpdateEmployee,
  IEmployee,
  IEmployeeDetail,
  IQueryChangeStatus,
  IQueryDeleteEmployee,
  IQueryEmployeeReview,
} from '~/utils/interface/employee';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const employeeApi = {
  getEmployeeList: (params: IQueryParamBase) => {
    const url = urlApiEmployee.getEmployeeList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IEmployee[]>>>(url, { params });
  },

  createEmployee: (formData: FormData) => {
    const url = urlApiEmployee.createEmployee;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getEmployeeDetail: (employeeId: string) => {
    const url = urlApiEmployee.getEmployeeDetail(employeeId);
    return axiosClient.get<IBaseResponse<IEmployeeDetail>>(url);
  },

  deleteEmployee: (params: IQueryDeleteEmployee) => {
    const url = urlApiEmployee.deleteEmployee;
    return axiosClient.delete<IBaseResponse>(url, { params });
  },

  updateEmployee: (params: IBodyUpdateEmployee) => {
    const { id, body } = params;
    const url = urlApiEmployee.updateEmployee(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  updateStatusEmployee: ({ employeeId, body }: IQueryChangeStatus) => {
    const url = urlApiEmployee.updateEmployeeStatus(employeeId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  uploadfileExcel(body: FormData) {
    const url = `${urlApiEmployee.uploadFileExcel}`;
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getEmployeeReview: (params: IQueryEmployeeReview) => {
    const { token, ...restParams } = params;
    const url = urlApiEmployee.getEmployeeReview(token);
    return axiosClient.get<IBaseResponse<IListDataResponse<IEmployee[]>>>(url, { params: restParams });
  },
};

export default employeeApi;
